<template>
    <div id="insurance_agency_create" class="fleet-form-main">
        <div :class="`loader${loaderClass}`" v-show="loading">
        </div>
        <div id="page-content-wrapper" class="admin-content-area">
            <template v-if="cantAccessPage === true">
                <div class="page-name">
                    <span class="page-name" id="insuranceAgencyHeader" v-if="$route.params.id > 0">Update Insurance Agency</span>
                    <span class="page-name" id="insuranceAgencyHeader" v-else>Add Insurance Agency</span>
                    <button type="submit" class="btn btn-secondary pull-right" v-on:click.prevent="BackInsuranceAgencyList">
                        <i class="fp-back"> </i> Back
                    </button>
                </div>
                <div class="container-fluid">
                    <div class="admin-page-content insurance-agency-crud">
                        <section class="internal-container border-top-table-fl">
                            <form autocomplete="off" class="form-horizontal basic-form-container metric-form" id="InsuranceAgencyForm">
                                <div class="form-row row-cols-md-4 row-cols-1">
                                    <div class="col form-group">
                                        <label class="control-label require" for="name">Name:</label>
                                        <input type="text" class="form-control" v-model="name" id="name" placeholder="Enter Name" name="name">
                                        <div class="field-error">{{name_error_msg}}</div>
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label require" for="contact_name">Contact Name:</label>
                                        <input type="text" class="form-control" v-model="contact_name" id="contact_name" placeholder="Enter Contact Name" name="contact_name">
                                        <div class="field-error">{{contact_name_error_msg}}</div>
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label require" for="phone">Phone:</label>
                                        <input type="text" class="form-control" v-cleave="{delimiter: '-',blocks: [3, 3, 4]}" v-model="phone" id="phone" placeholder="999-999-9999" name="phone">
                                        <!-- <input-mask id="phone" :alwaysShowMask="true" name="phone" v-model="phone" mask="999-999-9999 ext 99999999" class="form-control" type="tel"></input-mask> -->
                                        <div class="field-error">{{phone_error_msg}}</div>
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label require" for="fax">Fax:</label>
                                        <input type="text" class="form-control" v-cleave="{delimiter: '-',blocks: [3, 3, 4]}" v-model="fax" id="fax" placeholder="999-999-9999" name="fax">
                                        <!-- <input-mask id="fax" :alwaysShowMask="true" name="fax" v-model="fax" mask="999-999-9999" class="form-control" type="tel"></input-mask> -->
                                        <div class="field-error">{{fax_error_msg}}</div>
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label" for="email">Email:</label>
                                        <input type="text" class="form-control" v-model="email" id="email" placeholder="Enter Email" name="email">
                                        <div class="field-error">{{email_error_msg}}</div>
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label require" for="address_line_1"> Address Line 1: </label>
                                        <input type="text" class="form-control" v-model="address_line_1" id="address_line_1" placeholder="Enter Address Line 1" name="address_line_1">
                                        <div class="field-error">{{address_line_1_error_msg}}</div> 
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label" for="address_line_2"> Address Line 2: </label>
                                        <input type="text" class="form-control" v-model="address_line_2" id="address_line_2" placeholder="Enter Address Line 2" name="address_line_2">
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label" for="address_line_3"> Address Line 3: </label>
                                        <input type="text" class="form-control" v-model="address_line_3" id="address_line_3" placeholder="Enter Address Line 3" name="address_line_3">
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label require" for="city">City:</label>
                                        <input type="text" class="form-control" v-model="city" id="city" placeholder="Enter City Name" name="city">
                                        <div class="field-error">{{city_error_msg}}</div> 
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label require" for="state">State:</label>
                                        <v-select v-model="state" name="state"
                                                label="text" :filterable="false" :options="stateArr"
                                                @search="onSearchState"
                                                placeholder="Select State" class="custom-ci-auto-search">
                                            <template slot="no-options">
                                                Search State...
                                            </template>
                                            <template slot="option" slot-scope="option">
                                                <div class="d-center">
                                                    {{ option.text }}
                                                </div>
                                            </template>
                                            <template slot="selected-option" slot-scope="option">
                                                <div class="selected d-center">
                                                    {{ option.text }}
                                                </div>
                                            </template>
                                        </v-select>
                                        <div class="field-error">{{state_error_msg}}</div> 
                                    </div>
                                </div>
                                <div class="form-group">
                                    <div class="alert alert-warning hide offset-sm-2 col-sm-6" id="alertError">
                                        <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                                        <strong id="errorMsg" class="field-error"></strong>
                                    </div>
                                </div>
                                <div class="btn-groups">
                                    <button type="submit" id="CreateInsuranceAgencyBtn" v-if="$route.params.id > 0" class="btn btn-primary" v-on:click.prevent="CreateInsuranceAgency" >
                                    <i class="fp-reload"> </i>  Update
                                    </button>
                                    <button type="submit" id="CreateInsuranceAgencyBtn" v-else class="btn btn-primary" v-on:click.prevent="CreateInsuranceAgency" >
                                    <i class="fp-save"> </i>  Save
                                    </button>
                                    <button type="submit" id="createAndContinueInsuranceAgencyBtn" v-if="$route.params.id == undefined" class="btn btn-tertiary" v-on:click.prevent="CreateInsuranceAgency(flag='Save and Continue')" >
                                    <i class="fp-save-continue"> </i>  Save and Continue
                                    </button>
                                    <button type="submit" id="cancelInsuranceAgencyBtn" class="btn btn-tertiary" v-on:click.prevent="BackInsuranceAgencyList" >
                                    <i class="fp-close"> </i>  Cancel
                                    </button>
                                </div>
                            </form>
                        </section>        
                    </div>
                </div>
            </template>
            <template v-else-if="cantAccessPage === false">
                <div class="container-fluid">
                    <div class="bg-white text-center">
                        <h1>
                            Oops!</h1>
                        <h2>
                            403 </h2>
                        <div class="error-details">
                            Sorry!, You don't have permission to access this page.
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <loading-content></loading-content>
            </template>
            <app-footer></app-footer>
        </div>
    </div>
</template>
<script>
import Vue from "vue";

import {commonMixins} from '../mixins/commonMixins';

// import InputMask from 'vue-input-mask';
// Vue.component('input-mask', InputMask);

export default {
  name: "InsuranceAgencyCreate",
  
  metaInfo() {
     return {title: (this.$route.params.id > 0)? "Update Insurance Agency | " +process.env.COPYRIGHT_NAME : "Create Insurance Agency | " +process.env.COPYRIGHT_NAME}
  },
  mixins:[commonMixins],
  data: () => ({
    permissions: [],
    cantAccessPage: "",
    name: "",
    //code: "",
    contact_name:"",
    phone:"",
    fax:"",
    email:"",
    address_line_1:"",
    address_line_2:"",
    address_line_3:"",
    //city_id:null,
    city:"",
    //cityArr: [],
    state:null,
    stateArr: [],
    loading:false,
    name_error_msg: "",
    //code_error_msg: "",
    contact_name_error_msg:"",
    phone_error_msg:"",
    fax_error_msg:"",
    address_line_1_error_msg:"",
    city_error_msg:"",
    state_error_msg:"",
    email_error_msg:""
  }),
  watch:{

        //check permission change
        permissions: function (permissions) {

            var self = this;
            if (permissions.length > 0) {
                for (var i = 0; i < permissions.length; i++) {
                    if (permissions[i].name == 'add_insurance_agency') {
                        self.cantAccessPage = true;
                    }
                }
            }

        },       
   },
  created: function() {

  },
  mounted: function() {
        var self = this;
        self.getPermissions();

        setTimeout(function () {
            var path = window.location.pathname;
            var segments = path.split("/");
            
            if (segments[3]) {
                self.loadInsuranceAgency();
            }
        }, 100);
  },
  methods: {
      
    onSearchState(search, loading) {
        var self = this;
        if (search.length > 1) {

            loading(true);
            self.searchField(loading, search, 'state', '');
        }
    },

    BackInsuranceAgencyList() {
      var self = this;
        if(self.$route.params.redirectFrom == 'InsurancePolicyCreate' && self.$route.params.redirectFrom != undefined){
            self.$router.push({name: self.$route.params.redirectFrom});
            return;
        }
      self.$router.push("/insuranceagency/list");
    },

    CreateInsuranceAgency(flag) {
      
        var self = this;
        var error = false;
        var phoneRE = /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/;

        self.name_error_msg = "";
        //self.code_error_msg = "";
        self.contact_name_error_msg = "";
        self.fax_error_msg = "";
        self.phone_error_msg = "";
        self.address_line_1_error_msg = "";
        self.city_error_msg = "";
        self.state_error_msg = "";
        self.email_error_msg = "";

        if (!self.name || self.name == null || self.name == "") {
            self.name_error_msg = "Name Required.";
            error = true;
        }

        //   if (!self.code || self.code == null || self.code == "") {
        //     self.code_error_msg = "Code Required.";
        //     error = true;
        //   }

        //   if (!self.contact_name || self.contact_name == null || self.contact_name == "") {
        //     self.contact_name_error_msg = "Contact Name Required.";
        //     error = true;
        //   }

        if(self.fax != '___-___-____' && !self.fax.match(phoneRE)){
            self.fax_error_msg = "Fax must be in proper format";
            error = true;
        }

        if (!self.phone || self.phone == null || self.phone == "") {
            self.phone_error_msg = "Phone Required.";
            error = true;
        }

        var phoneArr = self.phone.split(" ext ");

        if(self.phone && !phoneArr[0].match(phoneRE)){
            self.phone_error_msg = "Phone must be in proper format";
            error = true;
        }
        
        if (!self.address_line_1 || self.address_line_1 == null || self.address_line_1 == "") {
            self.address_line_1_error_msg = "Address Line 1 Required.";
            error = true;
        }

        //if (self.city_id == null || !self.city_id.value) {
        if (self.city == null || self.city == "" ) {
            self.city_error_msg = "City Required.";
            error = true;
        } 

        if (self.state == null || !self.state.value) {
            self.state_error_msg = "State Required.";
            error = true;
        }

        if (self.email && !self.validEmail(self.email)) {
            self.email_error_msg = "Enter Valid Email.";
            error = true;
        }
      
        if (!error) {
            self.loading = true;
            var path = window.location.pathname;
            var segments = path.split("/");
            if (segments[3])
            {
                $("#CreateInsuranceAgencyBtn").val("Updating ...");
                $("#CreateInsuranceAgencyBtn").prop("disabled", true);
                $("#cancelInsuranceAgencyBtn").prop("disabled",true);
            } else {
                if (flag == "Save and Continue") {

                    $("#createAndContinueInsuranceAgencyBtn").val("Saving ...");
                    $("#CreateInsuranceAgencyBtn").prop("disabled", true);
                    $("#createAndContinueInsuranceAgencyBtn").prop("disabled", true);
                    $("#cancelInsuranceAgencyBtn").prop("disabled",true);

                }else{

                    $("#CreateInsuranceAgencyBtn").val("Saving ...");
                    $("#CreateInsuranceAgencyBtn").prop("disabled", true);
                    $("#createAndContinueInsuranceAgencyBtn").prop("disabled", true);
                    $("#cancelInsuranceAgencyBtn").prop("disabled",true);
                }
               
            }
            var fields = $("#InsuranceAgencyForm").serializeArray();
            fields.push({name: "state_id", value: self.state.value});
            //fields.push({name: "city_id", value: self.city_id.value});
            fields.push({name: "id", value: segments[3]});
            
            $.ajax({
                url: process.env.ROOT_API + "/insuranceagency/create",
                type: "POST",
                data: fields,
                headers: this.ajxHeaders,
                dataType: "json",
                success: function (data) {
                    self.loading = false;
                    if (segments[3])
                    {
                        $("#CreateInsuranceAgencyBtn").val("Update");
                        $("#CreateInsuranceAgencyBtn").prop("disabled", false);
                        $("#cancelInsuranceAgencyBtn").prop("disabled",false);
                    } else {
                        if (flag == "Save and Continue") {

                            $("#createAndContinueInsuranceAgencyBtn").val("Save and Continue");
                            $("#CreateInsuranceAgencyBtn").prop("disabled", false);
                            $("#createAndContinueInsuranceAgencyBtn").prop("disabled", false);
                            $("#cancelInsuranceAgencyBtn").prop("disabled",false);

                        }else{

                            $("#CreateInsuranceAgencyBtn").val("Save");
                            $("#CreateInsuranceAgencyBtn").prop("disabled", false);
                            $("#createAndContinueInsuranceAgencyBtn").prop("disabled", false);
                            $("#cancelInsuranceAgencyBtn").prop("disabled",false);

                        }
                    }
                    if (data.status == "success") {

                        if (flag == "Save and Continue") {

                            $("#InsuranceAgencyForm").trigger("reset");
                            self.name ="";
                            //self.code = "";
                            self.contact_name = "";
                            self.phone = "";
                            self.fax = "";
                            self.email = "";
                            self.address_line_1 = "";
                            self.address_line_2 = "";
                            self.address_line_3 = "";
                            //self.city_id = null;
                            self.city = "";
                            self.state = null;
                    
                        }else{
                            if(self.$route.params.redirectFrom == 'InsurancePolicyCreate' && self.$route.params.redirectFrom != undefined){

                                self.$router.push({name: self.$route.params.redirectFrom,params:{redirectTo: 'InsurancePolicyCreateFromAgency', agencyId: {value:data.content.id, text:data.content.name}}});
                                return;
                            }
                            self.$router.push("/insuranceagency/list");
                        }

                    } else {
                        if (data.content.length > 0) {
                            var err = "";
                            for (var i = 0; i < data.content.length; i++) {
                                err += data.content[i] + "<br>";
                            }
                            $("#errorMsg").html(err);
                            $(".alert-warning").toggleClass("show");
                            setTimeout(function () {
                                $(".alert-warning").removeClass("show");
                                $(".alert-warning").addClass("hide");
                            }, 10000);
                        }
                    }
                },
                error: function (jqXHR, exception) {
                    self.loading = false;
                    if (segments[3])
                    {
                        $("#CreateInsuranceAgencyBtn").val("Update");
                        $("#CreateInsuranceAgencyBtn").prop("disabled", false);
                        $("#cancelInsuranceAgencyBtn").prop("disabled",false);
                    } else {
                        if (flag == "Save and Continue") {

                            $("#InsuranceAgencyForm").trigger("reset");
                            

                            $("#createAndContinueInsuranceAgencyBtn").val("Save and Continue");
                            $("#CreateInsuranceAgencyBtn").prop("disabled", false);
                            $("#createAndContinueInsuranceAgencyBtn").prop("disabled", false);
                            $("#cancelInsuranceAgencyBtn").prop("disabled",false);

                        }else{

                            $("#CreateInsuranceAgencyBtn").val("Save");
                            $("#CreateInsuranceAgencyBtn").prop("disabled", false);
                            $("#createAndContinueInsuranceAgencyBtn").prop("disabled", false);
                            $("#cancelInsuranceAgencyBtn").prop("disabled",false);

                        }
                    }
                    self.generateStatusCodeMessage(jqXHR,true,'insurance-agecy-create')
                }
            });
        }else{
            self.errorValidationFocus();
        }
     
    },

    loadInsuranceAgency() {
        var path = window.location.pathname;
        var segments = path.split("/");
        var self = this;
        self.loading = true;
        $.ajax({
            url: process.env.ROOT_API + "/insuranceagency/" + segments[3],
            type: "GET",
            headers: this.ajxHeaders,
            dataType: "json",
            success: function (data) {
                self.loading = false;
                console.log(data);
                if (data.status == "success") {
                    self.name = data.content.name;
                    //self.code = data.content.code;
                    self.contact_name = data.content.contact_name;
                    self.phone = data.content.phone;
                    self.fax = data.content.fax;
                    self.email = data.content.email;
                    self.address_line_1 = data.content.address_line_1;
                    self.address_line_2 = data.content.address_line_2;
                    self.address_line_3 = data.content.address_line_3;
                    self.city = data.content.city;//{ text:data.content.cityName, value:data.content.city_id};
                    self.state = { text:data.content.stateName, value:data.content.state_id};
                } 
            },
            error: function (jqXHR, exception) {
                self.loading = false;
                self.generateStatusCodeMessage(jqXHR,false,'insurance-agecy-by-id')
            }
        });
    },
    validEmail: function(email) {
        var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(email);
    },
  }
};
</script>


// WEBPACK FOOTER //
// src/components/InsuranceAgencyCreate.vue